"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7326,9083],{

/***/ 67326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44790);
/* harmony import */ var src_utils_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13925);
/* harmony import */ var src_utils_formatCurrency__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13717);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);










const ChooseDeposit = _ref => {
  let {
    offerData,
    mt
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
  const priceVatIncluded = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state => state.nlt.priceVatIncluded);
  const {
    offer,
    selectableDeposits,
    hasDepositChoice,
    monthlyRateFromDeposit,
    selectVariationItem
  } = (0,src_utils_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useSelectableDeposits */ .gU)(offerData);

  if (!hasDepositChoice) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
    mt: mt,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X6, {
      as: "h3",
      fontSize: "1.125rem",
      fontFamily: "Montserrat-SemiBold",
      textAlign: "left",
      mb: "m",
      children: t('nltCustomizeOfferModalStepsComponent:step0.chooseDeposit')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Grid */ .rj, {
      templateColumns: "repeat(auto-fit, minmax(min(17rem, 100%), 1fr))",
      gap: "m",
      children: selectableDeposits.map(deposit => {
        const monthlyRate = monthlyRateFromDeposit(deposit);
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          onClick: () => selectVariationItem('deposit', deposit),
          title: `${(0,src_utils_formatCurrency__WEBPACK_IMPORTED_MODULE_7__/* .formatWithVat */ .EX)(deposit, priceVatIncluded)}€`,
          description: t('nltCustomizeOfferModalStepsComponent:ratePerMonth', {
            value: monthlyRate === null ? '- ' : (0,src_utils_formatCurrency__WEBPACK_IMPORTED_MODULE_7__/* .formatWithVat */ .EX)(monthlyRate, priceVatIncluded)
          }).toString(),
          selected: deposit === offer.deposit && monthlyRate !== null,
          disabled: monthlyRate === null
        }, deposit);
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ChooseDeposit);

/***/ }),

/***/ 44790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





const RichButton = _ref => {
  let {
    title,
    description,
    onHoverMessage,
    onClick,
    disabled,
    selected
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
    title: onHoverMessage || '',
    size: "lg",
    bg: disabled ? 'baseNeutral.100' : 'baseWhite',
    borderRadius: 10,
    borderColor: selected ? 'primaryGreen.600' : '#d9dde1',
    cursor: onClick ? 'pointer' : 'default',
    variant: "outline",
    width: "full",
    height: "auto",
    minHeight: "56px",
    py: "xs",
    whiteSpace: "normal",
    flexWrap: "wrap",
    onClick: onClick,
    disabled: disabled || false,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
      color: "baseDark",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "1.25rem",
      lineHeight: "1.625rem",
      letterSpacing: "0.57px",
      children: title
    }), description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
      color: "baseDark",
      ml: "xs",
      fontFamily: "Montserrat-Medium",
      fontWeight: "normal",
      fontSize: "0.75rem",
      lineHeight: "0.975rem",
      letterSpacing: "0.4px",
      children: description
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RichButton);

/***/ })

}]);